import { useContext, useEffect, useRef } from 'react'
import { UserContext, UserContextType } from '@/UserContext'
import { useHistory } from 'react-router-dom'

// Allows for conditional clearning of open media streams when the user leaves
// page. This avoids leaving the camera/mic open
export function useMediaStreamCleanup() {
    const history = useHistory()
    const { dispatch: userDispatch } = useContext(UserContext) as UserContextType
    const shouldCleanup = useRef(true)

    useEffect(() => {
        const unhistoryListen = history.listen((location) => {
            if (location.pathname.startsWith('/collaborate')) {
                shouldCleanup.current = false
            }
        })

        return () => {
            unhistoryListen()

            // Clear open media streams if the user is not moving to the
            // collaborate page.
            //
            // Wrapped with setTimeout to ensure other effects get an opportunity
            // to set shouldCleanup appropriately before we act on it.
            setTimeout(() => {
                if (shouldCleanup.current) {
                    userDispatch({
                        type: 'clear_media_selection_and_streams',
                        value: null,
                    })
                }
            })
        }
    }, [])
}
